<template>
  <div class="bookmark" :class="{deleted: this.deleted}">
    <template v-if="this.deleted">
      Deleted <a :href="bookmark.uri">{{ bookmark.uri }}</a>
    </template>
    <template v-else>
      <LinkCount
        class="bookmark-screenshot"
        :bookmarkId="bookmark.id"
        :link="bookmark.uri">
        <img v-if="bookmark.miniscreenshot" :src="hexaToImg(bookmark.miniscreenshot)" />
      </LinkCount>

      <div class="bookmark-info">
        <div class="bookmark-title">
          <LinkCount :bookmarkId="bookmark.id" :link="bookmark.uri">
            <img v-if="bookmark.favicon" :src="hexaToImg(bookmark.favicon)" />
          </LinkCount>

          <LinkCount
            class="bookmark-uri"
            :bookmarkId="bookmark.id"
            :link="bookmark.uri">
            {{ bookmark.uri }}
          </LinkCount>

          <Visit :visit="bookmark.visit"></Visit>
        </div>

        <Aliases
          :bookmarkId="bookmark.id"
          :link="bookmark.uri"
          :aliases="bookmark.privatealias"
          title="alias privé"
        ></Aliases>
        <Aliases
          :bookmarkId="bookmark.id"
          :link="bookmark.uri"
          :aliases="bookmark.publicalias"
          title="alias public"
        ></Aliases>

        <Description :description="bookmark.hldescription || bookmark.description"></Description>

        <!-- <span>{{ bookmark.authenticationinfo }}</span>  faire afficher une popup de modification de l'objet auth-->
        <AuthenticationInfo v-if="bookmark.authenticationinfo" :authenticationinfo="bookmark.authenticationinfo"></AuthenticationInfo>

        <a :href="'/history/' + bookmark.id + '?date=' + date"><BookmarkDate :creationDate="date" :updateDate="bookmark.updatedate"></BookmarkDate></a>
        <!-- <span>{{ bookmark.lang }}</span> -->
        <!-- <span>{{ bookmark.owner }}</span> si mon id n'est pas le meme alors c'est le bookmark d'un autre partage par un group -->
      </div>

      <div class="bookmark-tags">
        <Tags
          :tags="bookmark.tags"
          :hltags="bookmark.hltags || bookmark.tags"
        ></Tags>
      </div>

      <DropDown class="dropdown">
        <Button
          @click.prevent="edit"
          icon="icon-pencil"
        >
          Edit
        </Button>
        <Button
          @click="toggleConfirmationModal"
          icon="icon-trashcan"
        >
          Delete
        </Button>

        <ConfirmationModal
          :isOpen="showConfirmationModal"
          :message="'Do you want realy remove this bookmark ' + this.bookmark.uri + ' ?'"
          @confirm="deleteBookmark"
          @close="toggleConfirmationModal">
        </ConfirmationModal>
      </DropDown>

    </template>
  </div>
</template>

<script>
import { Component, Prop, Vue } from 'vue-property-decorator'
import Aliases from '@/components/bookmark/Alias'
import BookmarkDate from '@/components/common/BookmarkDate'
import Button from '@/components/common/Button'
import DropDown from '@/components/common/DropDown'
import Tags from '@/components/bookmark/Tags'
import AuthenticationInfo from '@/components/bookmark/AuthenticationInfo'
import Description from '@/components/bookmark/Description'
import LinkCount from '@/components/bookmark/LinkCount'
import Visit from '@/components/bookmark/Visit'
import ConfirmationModal from '@/components/layout/ConfirmationModal'

@Component({
  name: 'Bookmark',
  props: ['bookmark'],
  components: {
    Aliases,
    AuthenticationInfo,
    BookmarkDate,
    Button,
    ConfirmationModal,
    Description,
    DropDown,
    LinkCount,
    Tags,
    Visit
  }
})
class Bookmark extends Vue {
  @Prop bookmark
  deleted = false
  showConfirmationModal = false;

  get date() {
    return this.bookmark.importdate || this.bookmark.creationdate
  }

  edit() {
    this.$router.push({ name: 'Edit', params: { id: this.bookmark.id } })
  }

  deleteBookmark() {
    this.$fetch.delete(`/bookmarks/${this.bookmark.id}`).then(
      () => {
        this.deleted = true
      },
      (err) => {
        console.log('ko', err)
        this.errorMsg = err.cause
      }
    )
  }

  hexaToImg(hexa) {
    if (!hexa.startsWith('\\x')) {
      return 'data:image/png;base64,' + hexa
    }

    let a = []
    for (let i = 2, len = hexa.length; i < len; i += 2) {
      a.push(parseInt(hexa.substr(i, 2), 16))
    }

    let bytea = new Uint8Array(a)
    let base64 = btoa(String.fromCharCode.apply(null, bytea))
    return 'data:image/png;base64,' + base64
  }

  toggleConfirmationModal() {
    this.showConfirmationModal = !this.showConfirmationModal;
    console.log(this.showConfirmationModal)
  }
}

export default Bookmark
</script>

<style lang="less">
@import '../assets/less/globals';

.bookmark {
  position: relative;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;

  margin-bottom: var(--margin--small);
  padding: var(--margin--small) var(--margin--medium);

  background-color: var(--color-bookmark-bg);
  box-shadow: var(--default-ui-element-shadow);

  &.deleted {
    background-color: var(--color-separation-border);
  }

  .info{
    flex-grow: 2;
  }

  .info {
    display: flex;
    flex-direction: column;

    .info-header,
    .info-footer {
      margin: 2px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-start;
    }
  }

  Description {
    width: 100%;
  }
}

.bookmark-screenshot {
  position: absolute;
  right: 0;
  top: 0;

  width: 65px;
}

.bookmark-info {
  flex-grow: 1;
}

.bookmark-title {
  display: flex;
  align-items: baseline;

  & > * {
    margin-right: var(--margin--tiny);
  }
}

.bookmark-uri {
  padding-bottom: var(--margin--tiny);
  color: #555;
  line-height: var(--default-bookmark-title-height);

  &:hover {
    color: var(--color-hover);
  }
}

.bookmark-favicon {
  width: 20px;
  height: 20px;
  margin-right: var(--margin--small);
}

.bookmark-tags {
  flex-grow: 1;
}

.bookmark-uri a {
  color: inherit;
  font-weight: bold;
}

.bookmark:hover {
  box-shadow: -2px 2px 5px 1px rgba(0,0,0, 0.05);
}

.grid {
  .bookmark {
    flex-direction: column;
    overflow: auto;
  }

  .bookmark-info {
    max-width: 100%;
    padding-right: var(--margin--large);
  }

  .bookmark-tags {
    max-width: none;
    width: 100%;
    flex-grow: 0;
    .tags {
      flex-wrap: wrap-reverse;
      justify-content: center;
    }
  }

  .dropdown {
    position: absolute;
    top: var(--margin--small);
    right: var(--margin--small);
    z-index: 2;
  }
}

@media screen and (min-width: @screen-desktop-low) {
  .bookmark-info {
    max-width: 50%;
  }

  .bookmark-tags {
    max-width: 25%;
  }
}
</style>
